/* Behaviour for the Omi light homepage. Scoped to #omil. */
(function () {
  function init() {
    var root = document.getElementById('omil');
    if (!root || root.getAttribute('data-omil-ready')) return;
    root.setAttribute('data-omil-ready', '1');

    /* Real-life rail. Mandatory scroll snapping means we only ever land on an
       item's own offset, clamped to the furthest reachable one. Easing comes
       from CSS scroll-behavior, not a scrollTo option, so it stays observable. */
    var rail = root.querySelector('[data-rail]');
    if (rail) {
      var items = Array.prototype.slice.call(rail.querySelectorAll('article'));
      var prev = root.querySelector('[data-rail-prev]');
      var next = root.querySelector('[data-rail-next]');

      function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

      function offsetOf(i) {
        if (!items[i] || !items[0]) return 0;
        var raw = items[i].offsetLeft - items[0].offsetLeft;
        if (raw > maxScroll()) raw = maxScroll();
        if (raw < 0) raw = 0;
        return raw;
      }

      function currentIndex() {
        var best = 0, bestD = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(offsetOf(i) - rail.scrollLeft);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function sync() {
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft >= maxScroll() - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function goTo(i) {
        if (i < 0) i = 0;
        if (i > items.length - 1) i = items.length - 1;
        rail.scrollLeft = offsetOf(i);
        sync();
      }

      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    }

    /* Buy block gallery */
    var gal = root.querySelector('[data-gallery]');
    if (gal) {
      var main = gal.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.omil-gallery__thumbs button'));
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          if (main) {
            main.src = b.getAttribute('data-src');
            main.alt = b.getAttribute('aria-label') || '';
          }
          thumbs.forEach(function (o) { o.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      });
    }

    /* Tabbed FAQ */
    var faq = root.querySelector('[data-faq]');
    if (faq) {
      var tabs = Array.prototype.slice.call(faq.querySelectorAll('.omil-faqtabs button'));
      var panels = Array.prototype.slice.call(faq.querySelectorAll('.omil-faqbody > div'));
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var k = t.getAttribute('data-tab');
          tabs.forEach(function (o) { o.classList.remove('is-on'); });
          t.classList.add('is-on');
          panels.forEach(function (pn) {
            if (pn.getAttribute('data-panel') === k) { pn.classList.add('is-on'); }
            else { pn.classList.remove('is-on'); }
          });
        });
      });
    }

    /* Sticky offer chip */
    var chip = root.querySelector('[data-chip]');
    if (chip) {
      var x = chip.querySelector('[data-chip-x]');
      if (x) x.addEventListener('click', function () { chip.hidden = true; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
